import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { creatorWalletHistory } from '../../../Redux/Actions/CreatorBuyPackageAction'
import CustomPagination from '../../Common/CusstomPagination'
import { FaSpinner } from 'react-icons/fa6'
import DashboardFooter from '../../Common/DashboardFooter'

const WalletTable = () => {
    const dispatch = useDispatch()
    const [data, setData] = useState([])
    const [loader, setLoader] = useState({
        fetch: true
    })
    const [pagination, setPagination] = useState({
        currentPage: 1,
        totalItemOnPage: 20
    });
    const [totalLength, setTotalLength] = useState(0);

    const fetchData = () => {
        setLoader({
            ...loader,
            fetch: true
        })
        let formData = {
            "page": pagination.currentPage || 1
        }
        dispatch(creatorWalletHistory("creator-wallet", formData, setData, setTotalLength, setLoader, loader))
    }
    useEffect(() => {
        fetchData()
    }, [pagination.currentPage])

    return (
        <div className="account-block mx-2 mt-4 mb-3 mb-lg-5">
            <div className="task_border d-flex justify-content-between border-0 pb-2">
                <h6>All Earnings</h6>

            </div>

            <div className="table-responsive position-relative earnings_table mt-1">
                <table className="table theme-table">
                    <thead>
                        <tr>
                            <th>S.N.</th>
                            <th>Task Title</th>
                            <th>Package Name</th>
                            <th>Amount</th>
                            <th>Mode</th>
                            <th>Transtion Type</th>
                            <th>Date</th>


                        </tr>
                    </thead>

                    {loader.fetch ?
                        <div className='d-flex align-items-center justify-content-center' style={{ width: "100%", position: "absolute", top: "60px" }}>
                            <FaSpinner className="spin" style={{ fontSize: "20px" }} />
                        </div> :
                        <tbody>

                            {data.length > 0 ? data.map((curElem, i) => {
                                return (
                                    <tr key={i}>
                                        <td data-label="Task ID">{i + 1}</td>
                                        <td data-label="Task Title">{curElem.taskname}</td>
                                        <td data-label="Package Name">{curElem.packagename}</td>
                                        <td data-label="Amount">{curElem.amount}</td>
                                        <td data-label="Mode">
                                            <div className='earn_status complete' style={{ width: "fit-content" }}> {curElem.mode}</div>

                                        </td>
                                        <td data-label="Transtion Type">{curElem.transction_type}</td>
                                        <td data-label="Date">{curElem.created}</td>


                                    </tr>
                                )
                            }) : <td className='text-center pt-4' colSpan={7}>No wallet history</td>}

                        </tbody>
                    }
                </table>
                <div className='d-flex justify-content-end mb-2 mt-3'>
                    <CustomPagination
                        pagination={pagination}
                        setPagination={setPagination}
                        totalLength={totalLength}
                        loader={loader.fetch}
                    />
                </div>
            </div>

        </div>
    )
}

export default WalletTable